export default {"src":"/_next/static/media/valid-mail.32f1238e.svg","height":30,"width":42};